import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../apis/index";
import {
  GET_PLAYER_PROFILES,
  GET_PLAYER_PROFILES_SUCCESS,
  GET_PLAYER_PROFILES_FAIL,
  GET_PLAYER_PROFILE_DETAILS,
  GET_PLAYER_PROFILE_DETAILS_SUCCESS,
  GET_PLAYER_PROFILE_DETAILS_FAIL,
  GET_PLAYER_PROFILE_ENTRIES,
  GET_PLAYER_PROFILE_ENTRIES_SUCCESS,
  GET_PLAYER_PROFILE_ENTRIES_FAIL,
  GET_DISTINCT_PLAYERS,
  GET_DISTINCT_PLAYERS_SUCCESS,
  GET_DISTINCT_PLAYERS_FAIL,
  SEARCH_PLAYERS_WITH_SUGGESTIONS,
  SEARCH_PLAYERS_WITH_SUGGESTIONS_SUCCESS,
  SEARCH_PLAYERS_WITH_SUGGESTIONS_FAIL,
} from "../actions/playerprofile";

function* getPlayerProfiles(action) {
  try {
    const response = yield call(API.getPlayerProfiles);
    if (response.status === 200) {
      yield put({
        type: GET_PLAYER_PROFILES_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    yield put({ type: GET_PLAYER_PROFILES_FAIL, payload: error.message });
  }
}


function* getPlayerProfileDetails(action) {
  try {
    const response = yield call(API.getPlayerProfileById, action.payload);
    if (response.status === 200) {
      yield put({
        type: GET_PLAYER_PROFILE_DETAILS_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    yield put({ type: GET_PLAYER_PROFILE_DETAILS_FAIL, payload: error.message });
  }
}


function* getPlayerProfileEntries(action) {
  try {
    const response = yield call(API.getPlayerProfileEntries, action.payload);
    if (response.status === 200) {
      yield put({
        type: GET_PLAYER_PROFILE_ENTRIES_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    yield put({ type: GET_PLAYER_PROFILE_ENTRIES_FAIL, payload: error.message });
  }
}

function* getDistinctPlayers(action) {
  try {
    const { page, limit, search, startDate, endDate } = action.payload;
    const response = yield call(API.getDistinctPlayers, page, limit, search, startDate, endDate);
    yield put({
      type: GET_DISTINCT_PLAYERS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    yield put({ type: GET_DISTINCT_PLAYERS_FAIL, payload: error.message });
  }
}
function* searchPlayersWithSuggestions(action) {
  try {
    const response = yield call(API.searchPlayersWithSuggestions, action.payload);
    if (response.status === 200) {
      yield put({
        type: SEARCH_PLAYERS_WITH_SUGGESTIONS_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("Failed to search players with suggestions");
    }
  } catch (error) {
    yield put({ type: SEARCH_PLAYERS_WITH_SUGGESTIONS_FAIL, payload: error.message });
  }
}

function* playerprofileSaga() {
  yield takeLatest(GET_PLAYER_PROFILES, getPlayerProfiles);
  yield takeLatest(GET_PLAYER_PROFILE_DETAILS, getPlayerProfileDetails);
  yield takeLatest(GET_PLAYER_PROFILE_ENTRIES, getPlayerProfileEntries);
  yield takeLatest(GET_DISTINCT_PLAYERS, getDistinctPlayers);
  yield takeLatest(SEARCH_PLAYERS_WITH_SUGGESTIONS, searchPlayersWithSuggestions);
}

export default playerprofileSaga;
